import React,{useState}from'react';
import*as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';
import{serviceOptions}from'../data/serviceOptions';
import'./event-edit-modal.css';

const{FiSave,FiX}=FiIcons;

const eventTypes=[
  'Wedding',
  'Corporate Event',
  'Bar Mitzvah',
  'Bat Mitzvah',
  'B’nai Mitzvah',
  'Birthday',
  'Other'
];

function EventEditModal({event,onClose,onSave}){
  const isWooEvent=String(event.id).startsWith('woo-');
  const[form,setForm]=useState({
    name:event.name||'',
    client:event.client||'',
    email:event.email||'',
    phone:event.phone||'',
    type:event.type||'Wedding',
    date:event.date||'',
    venue:event.venue||'',
    guests:event.guests==='—'?'':event.guests||'',
    dj:event.dj==='TBD'?'':event.dj||'',
    status:event.status||'Not Started',
    wooStatus:event.wooStatus||'',
    eventDuration:event.eventDuration||'',
    eventStartTime:event.eventStartTime||'',
    setupStartTime:event.setupStartTime||'',
    eventEndTime:event.eventEndTime||'',
    returnDate:event.returnDate||'',
    returnTime:event.returnTime||'',
    pickupAddress:event.pickupAddress||'',
    services:Array.isArray(event.services)?[...event.services]:[],
    serviceDetails:event.eventDescription||event.serviceDetails||''
  });

  const update=(key,value)=>{
    setForm((current)=>({...current,[key]:value}));
  };

  const toggleService=(service)=>{
    setForm((current)=>({
      ...current,
      services:current.services.includes(service)
        ?current.services.filter((item)=>item!==service)
        :[...current.services,service]
    }));
  };

  const submit=(submitEvent)=>{
    submitEvent.preventDefault();
    const sharedDetails=form.serviceDetails.trim();

    onSave({
      ...event,
      ...form,
      name:form.name.trim(),
      client:form.client.trim(),
      email:form.email.trim(),
      phone:form.phone.trim(),
      venue:form.venue.trim(),
      dj:form.dj.trim()||'TBD',
      guests:form.guests===''?'—':form.guests,
      eventDuration:form.eventDuration.trim(),
      services:[...form.services],
      serviceDetails:sharedDetails,
      eventDescription:sharedDetails
    });
  };

  return(
    <div className="modal-backdrop">
      <form className="modal-card" onSubmit={submit}>
        <div className="modal-heading">
          <div>
            <span className="eyebrow">Event details</span>
            <h2>Edit event</h2>
          </div>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close edit event">
            <SafeIcon icon={FiX}/>
          </button>
        </div>

        {isWooEvent && <p className="read-only-note">Date, venue, guest count, times, and services are from WooCommerce. Edit them in WooCommerce.</p>}

        <div className="form-grid">
          <label>Event name<input required value={form.name} onChange={(event)=>update('name',event.target.value)}/></label>
          <label>Client name<input required value={form.client} onChange={(event)=>update('client',event.target.value)}/></label>
          <label>Email<input type="email" value={form.email} onChange={(event)=>update('email',event.target.value)}/></label>
          <label>Client phone number<input type="tel" value={form.phone} onChange={(event)=>update('phone',event.target.value)} placeholder="949-394-2572"/></label>
          <label>Event type<select value={form.type} onChange={(event)=>update('type',event.target.value)}>{eventTypes.map((type)=><option key={type}>{type}</option>)}</select></label>
          <label>Event date<input type="date" value={form.date} readOnly={isWooEvent} onChange={(event)=>update('date',event.target.value)}/></label>
          <label>Guest count<input type="number" min="0" value={form.guests} readOnly={isWooEvent} onChange={(event)=>update('guests',event.target.value)}/></label>
          <label>Assigned DJ<input value={form.dj} onChange={(event)=>update('dj',event.target.value)} placeholder="Assigned DJ or production team"/></label>
          <label>Event status<select value={form.status} onChange={(event)=>update('status',event.target.value)}>{['Not Started','In Progress','Under Review','Approved','Completed'].map((status)=><option key={status}>{status}</option>)}</select></label>
          {event.wooStatus && <label>Payment status<select value={form.wooStatus} onChange={(change)=>update('wooStatus',change.target.value)}>{['Deposit Due','Balance Due','Paid in Full','Event Completed'].map((status)=><option key={status}>{status}</option>)}</select></label>}
          <label className="form-field full">Venue<input value={form.venue} readOnly={isWooEvent} onChange={(event)=>update('venue',event.target.value)}/></label>
          <label>Event Duration<input value={form.eventDuration} readOnly={isWooEvent} onChange={(event)=>update('eventDuration',event.target.value)} placeholder="Example: 6 hours"/></label>
          <label>Event Start Time<input type="time" value={form.eventStartTime} readOnly={isWooEvent} onChange={(event)=>update('eventStartTime',event.target.value)}/></label>
          <label>Setup Start Time<input type="time" value={form.setupStartTime} readOnly={isWooEvent} onChange={(event)=>update('setupStartTime',event.target.value)}/></label>
          <label>Event End Time<input type="time" value={form.eventEndTime} readOnly={isWooEvent} onChange={(event)=>update('eventEndTime',event.target.value)}/></label>
          {form.serviceType === 'Self pickup and return' && <>
            <label>Return date<input type="date" value={form.returnDate} readOnly={isWooEvent} onChange={(event)=>update('returnDate',event.target.value)}/></label>
            <label>Return time<input type="time" value={form.returnTime} readOnly={isWooEvent} onChange={(event)=>update('returnTime',event.target.value)}/></label>
            <label className="form-field full">Pickup address<input value={form.pickupAddress} readOnly={isWooEvent} onChange={(event)=>update('pickupAddress',event.target.value)}/></label>
          </>}
          <fieldset className="choice-field form-field full services-picker">
            <legend>Services booked</legend>
            <p className="services-picker-help">Select every service included in this event.</p>
            <div className="services-picker-options">
              {serviceOptions.map((service)=>{
                const selected=form.services.includes(service);
                return <button type="button" key={service} className={selected?'selected':''} onClick={()=>toggleService(service)} aria-pressed={selected} disabled={isWooEvent}>
                  <span className="service-picker-check">{selected?'✓':''}</span><span>{service}</span>
                </button>;
              })}
            </div>
            <span className="services-picker-count">{form.services.length===0?'No services selected':`${form.services.length} ${form.services.length===1?'service':'services'} selected`}</span>
          </fieldset>
          <label className="form-field full"><span>Event description and service details</span><textarea rows="5" value={form.serviceDetails} onChange={(event)=>update('serviceDetails',event.target.value)} placeholder="Describe the event and add service specifications..."/></label>
        </div>
        <div className="modal-actions">
          <button type="button" className="button secondary" onClick={onClose}>Cancel</button>
          <button className="button primary"><SafeIcon icon={FiSave}/>Save details</button>
        </div>
      </form>
    </div>
  );
}

export default EventEditModal;